class BlockSliderHorizontal {

	constructor(){


		let mm = gsap.matchMedia();

		mm.add("(min-width: 992px)", () => {

			let sliders = document.querySelectorAll('.block-slider-horizontal');
			let swipersText = [];
			let swipersImage = [];

			sliders.forEach( (slider) => {

				const swiperText = slider.querySelector('.block-slider-text');
				const swiperImage = slider.querySelector('.block-slider-image');
				const swiperImageDuplicate = slider.querySelector('.block-slider-image-duplicate');
				const prev = slider.querySelector(".slider-button-prev");
				const next = slider.querySelector(".slider-button-next");

				let swiperImg = new Swiper(swiperImage, {
					speed: 700,
					allowTouchMove: false,
					slidesPerView: 1,
					effect: 'creative',
					noSwiping: true,
					noSwipingClass: 'swiper-slide',
					creativeEffect: {
						prev: {
							translate: ["-100%", 0, 0],
						},
						next: {
							translate: ['100%', 0, 0]
						}
					}
				});

				let swiperImgDuplicate = new Swiper(swiperImageDuplicate, {
					speed: 700,
					allowTouchMove: false,
					effect: 'creative',
					slidesPerView: 1,
					noSwiping: true,
					noSwipingClass: 'swiper-slide',
					creativeEffect: {
						prev: {
							translate: ["-100%", 0, 0],
						},
						next: {
							translate: ['100%', 0, 0],
						},
					}
				});

				let swiperTxt = new Swiper(swiperText, {
					// direction: "vertical",
					speed: 700,
					slidesPerView: 1,
					effect: 'creative',
					creativeEffect: {
						prev: {
							opacity: 0
						},
						next: {
							opacity: 0
						},
					},
					navigation: {
						prevEl: prev,
						nextEl: next
					},
					on: {
						"slideChangeTransitionStart" : (self) => {
							self.isAnimating = true;
							prev.style.pointerEvents = "none";
							next.style.pointerEvents = "none";
						},
						"slideChangeTransitionEnd" : (self) => {
							self.isAnimating = false;
							prev.style.pointerEvents = "unset";
							next.style.pointerEvents = "unset";
						},
						"slideNextTransitionStart" : (self) => {
							swiperImage.classList.toggle('reverse-animation', false);
							swiperImageDuplicate.classList.toggle('reverse-animation', false);
						},
						"slidePrevTransitionStart" : (self) => {
							swiperImage.classList.toggle('reverse-animation', true);
							swiperImageDuplicate.classList.toggle('reverse-animation', true);
						}
					}
				});

				swipersText.push(swiperTxt);
				swiperTxt.controller.control = [swiperImg, swiperImgDuplicate];

			});

			return () => { // optional
				swipersText.forEach( (s) => {
					s.destroy();
				});
				swipersImage.forEach( (s) => {
					s.destroy();
				});
			};

		});

	}

}
